/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaterialAvailableAtLocation } from '../../models/material-available-at-location';

export interface GetMaterialAvailableForProductionOrderAndArticle$Params {
  workCenterId: number;
  productionOrderId: number;
  articleId: number;
}

export function getMaterialAvailableForProductionOrderAndArticle(http: HttpClient, rootUrl: string, params: GetMaterialAvailableForProductionOrderAndArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<MaterialAvailableAtLocation>> {
  const rb = new RequestBuilder(rootUrl, getMaterialAvailableForProductionOrderAndArticle.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('productionOrderId', params.productionOrderId, {});
    rb.path('articleId', params.articleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MaterialAvailableAtLocation>;
    })
  );
}

getMaterialAvailableForProductionOrderAndArticle.PATH = '/api/v1/SecondaryMaterial/{workCenterId}/productionOrders/{productionOrderId}/materialAvailable/articles/{articleId}';
